import AlertBox from '@shared/components/AlertBox.tsx';
import { AxiosError } from 'axios';
import { isFluentResultError } from '@shared/features/error-handling/utils';


const renderErrorMessage = (error: AxiosError) => {
    if (isFluentResultError(error.response?.data)) {
        return (
            <>
                {' '}
                <p>
                    Det beror på följande:
                    <ul className='ml-1'>
                        {error.response.data.map((x, key) => (
                            <li key={key}>{x.message}</li>
                        ))}
                    </ul>
                </p>
                <p>
                    Kontakta oss på{' '}
                    <a
                        href='tel:010-480 30 00'
                        className='text-nowrap'
                    >
                        010-480 30 00
                    </a>{' '}
                    så hjälper vi dig att lösa problemet.
                </p>
            </>
        );
    }

    switch (error.status) {
        default:
            return (
                <>
                    {' '}
                    <p>
                        Det kan bero på något av följande:
                        <ul className='ml-1'>
                            <li>Du är saknar ett medlemskap</li>
                            <li>Ditt medlemskap är inte aktiverat</li>
                            <li>Driftstörningar på Mina Sidor</li>
                        </ul>
                    </p>
                    <p>
                        Vid akuta frågor kontakta oss på:{' '}
                        <a
                            href='tel:010-480 30 00'
                            className='text-nowrap'
                        >
                            010-480 30 00
                        </a>
                        .
                    </p>
                </>
            );
    }
};

interface IAuthenticationErrors{
    error:AxiosError,
}
const AuthenticationErrors = ({error}:IAuthenticationErrors) => {
    return (
        <AlertBox theme={'danger'}>
            <h5 className='mb-3'>Vi kunde inte logga in dig på Mina Sidor</h5>
            {renderErrorMessage(error)}
        </AlertBox>
    );
};

export default AuthenticationErrors;
